export default __webpack_public_path__ + "static/media/storage-services.23ccbb67.png";